import { Component, OnInit, AfterViewInit } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
declare let $: any;

@Component({
  selector: 'app-grievance-registration-form',
  templateUrl: './grievance-registration-form.component.html',
  styleUrls: ['./grievance-registration-form.component.scss']
})
export class GrievanceRegistrationFormComponent implements OnInit, AfterViewInit {
  grievanceForm: FormGroup; 
  submitted = false; 
  constructor(private formBuilder: FormBuilder, private http: HttpClient, private _router: Router) {
    this.grievanceForm = this.formBuilder.group({
      category: [''],
      program_name: ['', Validators.required],
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],      
      specialization: ['', Validators.required],
      semester: [''],
      section: [''],
      message: ['',  Validators.required]  
    })
  }
  get f() { return this.grievanceForm.controls; }

  submitForm(){
    this.submitted=true;
    if(this.grievanceForm.invalid){
      return;
    }
    var formData: any = new FormData();

    formData.append("category", this.grievanceForm.value.category);
    formData.append("program_name", this.grievanceForm.value.program_name);
    formData.append("name", this.grievanceForm.value.name);
    formData.append("email", this.grievanceForm.value.email);
    formData.append("phone", this.grievanceForm.value.phone);
    formData.append("specialization", this.grievanceForm.value.specialization);    
    formData.append("semester", this.grievanceForm.value.semester);
    formData.append("section", this.grievanceForm.value.section);    
    formData.append("message", this.grievanceForm.value.message);
     //console.log(formData);
     this.http.post('https://ghrcacs.raisoni.net/php_pages/grievance_form.php', formData).subscribe(
      (response) => console.log(response),
      (error) => console.log(error)
    );
    // this.router.navigate(['/demo']);
    this._router.navigateByUrl('/thank-you');
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    
  
    $(".staff").click(function(){
      $("#semester-field").hide();
      $("#section-field").hide();
    });
    $(".student").click(function(){
      $("#semester-field").show();
      $("#section-field").show();
    });   
}
}
